import { PageQuery } from './common.model';
import { Product, ProductQueryType } from './product.model';

export interface UserOrderInfo {
  userId: number;
  username: string;
  phone: number;
  address: string;
  fullName: string;
}

export interface UserOrder {
  id: number;
  orderCode: string;
  orderName: string;
  totalAmount: number;
  evidenceImage: string;
  status: UserOderStatus;
  providerDiscount: string;
  commissionAmount: number;
  details: UserOrderDetail[];
  userInfo: UserOrderInfo;
  orderBy: UserOrderInfo;
  createdDate: string;
  createdBy: string;
  feedback: boolean;
  payType: PayType;
}

export interface UserOrderDetail {
  productId: number;
  productName: string;
  commission: number;
  cost: number;
  quantity: number;
  point: number;
  nutriShopName: string;
  nutriShopId: number;
  accumulationAmount: number;
  image: string;
}

export enum UserOderStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  REJECTED = 'REJECTED',
}

export interface Cart {
  // cần sửa lại model cho đúng dạng data
  totalPrice: number;
  items: CartItem[];
  orderCode: string;
  totalCommissionPrice: number;
  paymentPrice: number;
}

export interface CartItem {
  cost: number;
  quantity: number;
  product: Product;
  commission: number;
  productType: ProductQueryType;
}

export enum PayType {
  cash = 'CASH',
  wallet = 'WALLET',
}

export interface UserOrderRequest {
  evidenceImage: string;
  phone: string;
  address: string;
  details: UserOrderRequestItem[];
  orderName?: string;
  orderCode: string;
  payType: PayType;
}

export interface UserOrderRequestItem {
  productId: number;
  quantity: number;
  salePrice: number;
}

export interface CartItemRequest {
  productId: number;
  quantity: number;
}

export interface OrderSearchQuery extends PageQuery {
  status: UserOderStatus | '';
}

export interface CheckCartResponse {
  id: number[];
  required: number;
}
